
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512","width":"512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M452 256c0-9.462-.686-18.948-2.043-28.314l60.897-42.267-66.303-114.838-67.063 31.61c-14.952-11.843-31.379-21.344-49.033-28.359L322.302 0H256l-60 256 60 196a195.841 195.841 0 00121.482-42.193l67.069 31.612 66.302-114.839-60.897-42.267A197.545 197.545 0 00452 256z","fill":"#4175df"}}),_c('path',{attrs:{"d":"M189.698 0l-6.153 73.832c-17.654 7.015-34.081 16.516-49.033 28.359l-67.063-31.61L1.146 185.419l60.897 42.267C60.686 237.052 60 246.538 60 256s.686 18.948 2.043 28.314L1.146 326.581 67.448 441.42l67.069-31.612A195.851 195.851 0 00256 452V0z","fill":"#4086f4"}}),_c('path',{attrs:{"d":"M278.5 121.863v96.927l-22.5 18-40 137.605L256 512h67.5V374.091C364.425 350.647 392 306.545 392 256c0-67.445-49.098-123.413-113.5-134.137z","fill":"#c6cfd5"}}),_c('path',{attrs:{"d":"M233.5 218.791v-96.927C169.098 132.587 120 188.555 120 256c0 50.545 27.575 94.647 68.5 118.091V512H256V236.791z","fill":"#e3e7ea"}})])
          )
        }
      }
    